import apiUrl from './api';
import { getWithAuth, postWithAuth } from '@/lib/httpAdapter';

// --- home onboarding latch ---
//
// Split out of homePageApi.ts: this is the only home API used on first
// paint (HomeRouter's onboarding-status latch), while everything else in
// homePageApi.ts backs the member-view widgets, which HomeRouter loads
// lazily via `dynamic()`. Keeping this pair in its own module keeps that
// lazy-only code out of HomeRouter's eager chunk.

export interface GetInternalOnboardingHomeResponse {
  value: number;
  Error?: string | null;
}

export interface SetInternalOnboardingHomeResponse {
  success: boolean;
  Error?: string | null;
}

export async function fetchInternalOnboardingHome(
  orgUUID: string
): Promise<GetInternalOnboardingHomeResponse> {
  const response = await getWithAuth(
    `${apiUrl}getInternalOnboardingHome/?OrgUUID=${encodeURIComponent(orgUUID)}`
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch home onboarding: ${response.status} ${response.statusText}`
    );
  }
  const data = await response.json();
  const parsed = typeof data === 'string' ? JSON.parse(data) : data;
  if (!parsed || typeof parsed !== 'object') {
    throw new Error('Invalid response format from server');
  }
  return parsed;
}

export async function setInternalOnboardingHome(
  orgUUID: string,
  done: 0 | 1
): Promise<SetInternalOnboardingHomeResponse> {
  const response = await postWithAuth(`${apiUrl}setInternalOnboardingHome/`, {
    OrgUUID: orgUUID,
    done,
  });
  if (!response.ok) {
    throw new Error(
      `Failed to set home onboarding: ${response.status} ${response.statusText}`
    );
  }
  const data = await response.json();
  const parsed = typeof data === 'string' ? JSON.parse(data) : data;
  if (!parsed || typeof parsed !== 'object') {
    throw new Error('Invalid response format from server');
  }
  return parsed;
}
